// this is an autogenerated file from App/Account/Content/Tasks/New/Menu/Expanded/BoardsList/Content/BoardItem/AssignedToMe/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Menu_Expanded_BoardsList_Content_BoardItem_AssignedToMe($user_id: uuid!, $board_id: uuid!) {
  tasks_assignees_aggregate(
    where: {
      user_id: { _eq: $user_id }
      task: { board_id: { _eq: $board_id }, stage: { done: { _eq: false } } }
    }
  ) {
    aggregate {
      count
    }
  }
}

`